import { Anchor as AntAnchor, AnchorProps, AnchorLinkProps } from 'antd';
import { AnchorLinkItemProps } from 'antd/es/anchor/Anchor';

export const Anchor = AntAnchor;

export type { AnchorProps, AnchorLinkProps, AnchorLinkItemProps };
